/**
 * A multi-select filter as the comma list the report APIs take, or nothing.
 *
 * Every option selected means "no restriction", so no filter is sent: the
 * result is the same, and the URL stays short. With every ID in the query
 * string, a tenant with a few hundred categories blew past nginx's 8 KB
 * request-line limit on "Select all" (414), which the page showed as no data.
 */
export function idFilterParam(selected: string[], options: { value: string }[]): string | undefined {
  if (selected.length === 0) return undefined;
  if (options.length > 0 && selected.length >= options.length) return undefined;
  return selected.join(',');
}
